import _ from 'lodash';
import {
  Events,
  getSegmentModelMetadata,
  getTealiumRedesignEvents,
  handleAnalytics,
  handleTealiumButtonAction,
  SEGMENT_HERO_COLLECTION_TITLE,
  setSegmentContextSourceLive,
  setTealiumSourceCollectionGlobal,
  getRecommendationIdDataForItem,
} from '@foxcorp/delta-web-analytics';

import { amplitudeTestName, EXPERIMENTS } from 'helpers/AmplitudeHelper';
import { logPlayerEvent } from 'helpers/LogReportHelpers';

const setRecommendationIdOnClick = (items, selectedItem, additionalFunctions) => {
  const recommendationIdData = getRecommendationIdDataForItem(items, selectedItem);
  additionalFunctions?.setRecommendationId(recommendationIdData);
};

const getAnaltytics = ({ panel = {}, item = {}, account, idx }) => {
  const { latestEpisode = {}, name, originalVideo, subtitle, title, videoId, description } = item;
  const { uID: episodeuID, showCode } = latestEpisode;
  const {
    collectionType,
    headline,
    isPanelRecommended,
    items,
    panelId,
    totalCollections,
    totalItems,
    uID,
  } = panel;

  const isLive = !!item?.livePlayerScreenUrl;
  const headerImageState = isLive ? 'live video' : 'autoplay video';
  const featuredTitle = headline || name;
  const showcaseType = collectionType?.replace('showcase', '')?.toLowerCase();
  return {
    collectionType,
    headerImageState,
    headline,
    isLive,
    item,
    name,
    panel,
    title,
    totalCollections,
    totalItems,
    tealiumCollectionEvents(buttonText) {
      const tealiumRedesignEvents = getTealiumRedesignEvents({ account });
      tealiumRedesignEvents.heroItemSelect({
        account,
        type: 'hero',
        state: 'autoplay video',
        containerTitle: name,
        verticalPosition: '1',
        horizontalPosition: idx + 1,
        title,
        subtitle: buttonText,
        cc: 'cc off',
        volume: 'volume off',
        collectionTitle: headline,
        collectionType,
        playlistLength: totalItems,
        collectionCount: totalCollections,
        item,
      });
    },
    handleSegmentSeriesItemClick(buttonText) {
      const props = {
        page_action_type: 'watch',
        page_collection_count: 1,
        page_collection_id: episodeuID || showCode,
        page_collection_title: SEGMENT_HERO_COLLECTION_TITLE,
        page_item_type: showcaseType ? `hero-showcase-${showcaseType}` : 'showcase',
        page_item_state: 'static image',
        page_item_container_title: name,
        page_item_vertical_position: '1',
        page_item_horizontal_position: '1',
        page_item_title: name,
        page_item_subtitle: description,
        page_item_cc: 'cc off',
        page_item_volume: 'volume off',
        page_playlist_length: 1,
        page_video_uid: episodeuID || uID || showCode,
        ...getSegmentModelMetadata(),
      };
      handleAnalytics({
        event: Events.HERO_ITEM_SELECT_ACTION,
        payload: props,
      });
    },
    handleSegmentUpsellItemClick(buttonText) {
      const pageTestName = amplitudeTestName(EXPERIMENTS.WEB_ANON_CTA);

      const props = {
        page_action_type: 'watch',
        page_collection_count: 1,
        page_collection_id: episodeuID || showCode,
        page_test_name: pageTestName,
        page_collection_title: SEGMENT_HERO_COLLECTION_TITLE,
        page_item_type: showcaseType ? `hero-showcase-${showcaseType}` : 'showcase',
        page_item_state: 'static image',
        page_item_container_title: name,
        page_item_vertical_position: '1',
        page_item_horizontal_position: '1',
        page_item_title: name,
        page_item_subtitle: description,
        page_item_cc: 'cc off',
        page_item_volume: 'volume off',
        page_playlist_length: 1,
        page_video_uid: episodeuID || uID || showCode,
        ...getSegmentModelMetadata(),
      };
      handleAnalytics({
        event: Events.HERO_ITEM_SELECT_ACTION,
        payload: props,
      });
    },
    handleSegmentItemClick(buttonText) {
      const props = {
        page_action_type: buttonText,
        page_collection_count: totalCollections,
        page_collection_id: panelId,
        page_collection_title: SEGMENT_HERO_COLLECTION_TITLE,
        page_collection_type: collectionType,
        page_item_type: showcaseType ? `hero-showcase-${showcaseType}` : 'showcase',
        page_item_state: headerImageState,
        page_item_container_title: title,
        page_item_vertical_position: '1',
        page_item_horizontal_position: idx + 1,
        page_item_title: name,
        page_item_subtitle: subtitle,
        page_item_cc: 'cc off',
        page_item_volume: 'volume off',
        page_playlist_length: totalItems,
        page_recs_collection: isPanelRecommended,
        page_video_uid: uID || showCode,
        ...getSegmentModelMetadata(),
      };
      handleAnalytics({
        event: Events.HERO_ITEM_SELECT_ACTION,
        payload: props,
      });
    },
    handleLiveClick(additionalFunctions) {
      setSegmentContextSourceLive(true);
      additionalFunctions?.saveLiveVideo(originalVideo);
    },
    logPlayer() {
      logPlayerEvent('onVideoPlayClick', { video_id: videoId, video_name: name });
    },
    onHandleTealiumButtonAction({ text }) {
      handleTealiumButtonAction({
        text,
        title,
        subtitle: name,
        account,
      });
    },
    onSelection({ itemIndex, additionalFunctions }) {
      _.set(window, 'context.segment.home.sourceName', featuredTitle);
      const selectedItem = itemIndex !== null ? itemIndex + 1 : 0;
      const data = {
        title: featuredTitle,
        collectionType,
        items,
        selectedItem,
      };
      setRecommendationIdOnClick(items, selectedItem, additionalFunctions);
      setTealiumSourceCollectionGlobal(data);
    },
  };
};

export default getAnaltytics;
